<template lang="pug">
.v-description.description(v-if="description")
	.description__container
		.description__wrapper
			.description__title(v-if="description.title") {{description.title}}
			.description__text-wrapper(:class="{'description__text--active': isActive}")
				.description__text.text-guide(v-if="description.text"
						ref="descriptionText"
						v-html="description.text")
				.description__text-btn(v-if="isButtonShown" @click="isActive = !isActive")
					| {{isActive ? 'Свернуть' : 'Читать полностью'}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			description: null,
			isActive: false,
			linesCount: 10,
			isButtonShown: false
		};
	},

	mounted() {
		window.addEventListener('resize', this.handleResize);
		this.checkTextHeight();
	},

	beforeUnmount() {
		window.removeEventListener('resize', this.handleResize);
	},

	methods: {
		dataSet(data) {
			this.description = data;
			this.$nextTick(() => {
				this.checkTextHeight();
			});
		},

		handleResize() {
			this.checkTextHeight();
		},

		checkTextHeight() {
			const descriptionText = this.$refs['descriptionText'];
			if (descriptionText) {
				let lineHeight = parseFloat(getComputedStyle(descriptionText).lineHeight);
				if (isNaN(lineHeight)) {
					lineHeight = 20;
				}
				const maxHeight = lineHeight * this.linesCount;
				this.isButtonShown = descriptionText.scrollHeight > maxHeight;
			}
		}
	}
};
</script>